import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasV2Sales1PTotalSalesSplineChart = () => {
  return (
    <AtlasV2ComparableSplineChart
      fieldName="onePSales"
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      title="1P Retail Sales as % of Total"
      marketShareKey={['onePSales_sum_value', 'retailSales_sum_value']}
      marketShareBuilder={(rb) => {
        return rb.modifyAggregation((agg) =>
          agg.removeAggregationField('onePSales').addAggregationField('retailSales', 'retailSales', 'sum', true)
        );
      }}
    />
  );
};

export default AtlasV2Sales1PTotalSalesSplineChart;
